import { ReactNode } from 'react';
import iModalStyle from './IModal.module.scss';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
    isOpen: boolean;
    closeModalHandler: () => void;
    children: ReactNode;
    label?: string;
}

const IModal = (props: IProps) => {
    const { isOpen, closeModalHandler, children, label } = props;

    return (
        <Modal open={isOpen} onClose={closeModalHandler} aria-label={label}>
            <div className={iModalStyle.modal}>
                <button type='button' className={iModalStyle.close} onClick={closeModalHandler} aria-label='Close'>
                    <CloseIcon />
                </button>
                <div className={iModalStyle.body}>{children}</div>
            </div>
        </Modal>
    );
};

export default IModal;
